// Externe Bibliotheken
import React, { Component } from 'react';
import { Scrollbar } from 'smooth-scrollbar-react';
import _ from 'lodash';
import axios from 'axios';

// Interne Module
import * as storage from '@/_helper/storage';
import { calculateAge, convertDate, convertPrice } from '@/_helper/mapper';
import { makeHash } from '@/_helper/main';
import tracking from '@/_helper/tracking';
import { seating_arrangements } from './_config';

// Komponenten
import Header from '@/comp/header/Header';
import Footer from '@/comp/footer/Footer';
import ProgressBar from '@/comp/loadingOffersBar/ProgressBar';
import StatusPage from '@/comp/statusPage/statusPage';
import { DetectMultipleTabs } from '@/comp/multipleTabs/multipleTabs';
import { BackButton } from '@/comp/backButton/backButton';

// Styles
import './seat-reservation.scss';

let params = {
    cancelVacancy: null,
    processToken: makeHash(32),
    errorWording: {
        seat: {
            'new-seat': 'Bitte neuen Sitzplatz auswählen.',
        },
        submit: {
            'min-pax-select': 'Bitte wählen Sie mindestens einen Reisenden für Ihren Hinflug / Rückflug aus.',
            'no-pax-select': 'Bitte wählen Sie mindestens einen Reisenden aus.',
            'new-seats':
                'Die gewählten Sitze stehen leider nicht mehr zur Verfügung. Bitte treffen Sie eine neue Auswahl.',
        },
    },
};

let mappingSeatCategory = {
    standard: {
        name: 'Standardsitz',
    },
    xleg: {
        name: 'XLeg Sitz',
        info: 'extra Platz & Komfort',
    },
};

class Index extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            hasResult: false,
            bookingData: storage.get('bookingData') !== null ? storage.get('bookingData') : null,
            legs: [],
            legIndexToOpen: 0,
            currentLeg: 0,
            participants: [],
            layers: {
                EmergencySeat: {
                    show: false,
                },
            },
            totalSurcharge: 0,
            formVacancy: false,
            formSubmit: false,
            formErrors: {
                seat: 'Bitte wählen Sie alle Sitze aus.',
                submit: {
                    state: false,
                    responseText: '',
                },
            },
            error: null,
        };
    }

    componentDidMount() {
        document.title = 'Sitzplatzreservierung' + window.$documentTitle;
        document.querySelector('html').classList.add('redesign');

        const bookingData = storage.get('bookingData');

        if (
            bookingData &&
            bookingData.data?.allowSeatReservations &&
            (bookingData.data?.serviceInformation?.flight !== undefined ||
                bookingData?.data?.isAllPossibleSeatsBooked === false)
        ) {
            let current = 0;
            this.setState((state) => {
                for (let i = 0; i < Object.keys(this.state.participants).length; i++) {
                    if (this.state.participants[i].seat.legs[this.state.currentLeg].booked === false) {
                        current = i;
                        break;
                    }
                }

                state.isLoading = true;
                state.current = current;
                return state;
            });

            this.getParticipants();
            this.$participantsContainer = React.createRef();

            this.getAncillaries();

            // get : set bookingParams
            if (storage.get('bookingData') !== null && storage.get('bookingData').bookingParams !== undefined) {
                this.setState({
                    bookingParams: storage.get('bookingData').bookingParams,
                });
            } else {
                //  service : flight serviceInformation not defined
                this.getBookingParams();
            }

            tracking('loaded', 'seatReservation');
        } else {
            window.location.href = '/';
            return false;
        }
    }

    getBookingParams() {
        if (storage.get('access_token') !== null) {
            const loginData = {
                requestType: 'bookingData',
                bookingId: storage.get('bookingNumber'),
                action: 'getBookingParams',
                clientId: 'customerarea',
                requestSource: 'AurumTours-Customerarea',
                hash: storage.get('access_token'),
            };

            axios({
                url: window.$serviceUrl + '/bookingData?token=' + window.$token,
                method: 'POST',
                data: loginData,
            })
                .then((response) => response)
                .then((data) => {
                    let response = data.data.data.data;

                    if (response !== null) {
                        this.setState({
                            bookingParams: response,
                        });

                        let bookingData = _.assign(storage.get('bookingData'), {
                            bookingParams: response,
                        });

                        storage.set('bookingData', bookingData);
                    }
                })
                .catch((error) =>
                    this.setState({
                        error,
                    })
                );
        }
    }

    getParticipants() {
        let bookingData = {
            ...this.state.bookingData,
        };

        if (storage.get('bookingData') === null) {
            return false;
        }

        let participants = {};
        let theIndex = 0;

        if (
            bookingData?.data !== null &&
            bookingData.data.frontendParams !== undefined &&
            bookingData.data.frontendParams.travellers !== undefined
        ) {
            let travellers = bookingData.data.frontendParams.travellers;
            Object.keys(travellers).forEach((value, index) => {
                let age = calculateAge(new Date(convertDate(travellers[value].birthDate)));

                let participantType = 'adult';
                switch (true) {
                    case age >= 2 && age < 15:
                        participantType = 'child';
                        break;
                    case age < 2:
                        participantType = 'infant';
                        break;
                    default:
                        participantType = 'adult';
                }

                participants[index] = {
                    surname: travellers[value].surName,
                    forename: travellers[value].foreName,
                    success: false,
                    seat: false,
                    participantType: participantType,
                };
            });

            // pre select
            theIndex = _.filter(participants, function (o) {
                return o.success;
            }).length;
            participants[theIndex].current = true;
        }

        this.setState({
            participants: participants,
            current: theIndex,
        });
    }

    preSelect() {
        this.preSelectBookedParticipants();
        this.preSelectBookedLegs();
        this.setBookedSeats();
    }

    preSelectBookedParticipants() {
        // get : set bookStates
        if (JSON.parse(sessionStorage.getItem('bookStates')) !== null) {
            this.setState({
                isLoading: true,
            });
            let bookingStats = JSON.parse(sessionStorage.getItem('bookStates'));

            // clean up data
            delete bookingStats.processToken;
            delete bookingStats.vacancyToken;
            delete bookingStats.vacancyData;

            sessionStorage.setItem('bookStates', JSON.stringify(bookingStats));

            let currentLeg = this.state.currentLeg;
            let legs = {
                ...this.state.legs,
            };
            let participants = {
                ...this.state.participants,
            };

            // set participants
            if (bookingStats.participantsData !== undefined) {
                Object.keys(participants).forEach((v) => (participants[v].success = false));

                Object.keys(bookingStats.participantsData).forEach((value) => {
                    participants[value].seat = {};
                    participants[value].seat.legs = {};

                    if (bookingStats.participantsData[value] !== undefined) {
                        Object.keys(bookingStats.participantsData[value].seat).forEach((pV, pI) => {
                            // set seat cat
                            Object.keys(mappingSeatCategory).forEach((v, i) => {
                                if (bookingStats.participantsData[value].seat[pI]?.cat !== undefined) {
                                    if (
                                        bookingStats.participantsData[value].seat[pI].cat.name ===
                                        mappingSeatCategory[v].name
                                    ) {
                                        bookingStats.participantsData[value].seat[pI].cat = v;
                                    }
                                }
                            });

                            if (bookingStats.participantsData[value]?.seat[parseInt(pV)]?.offerKey !== undefined) {
                                bookingStats.participantsData[value].seat[parseInt(pV)].success = true;
                                participants[value].success = true;
                            }

                            // set participants count
                            legs[pI].participants = legs[pI].participants + 1;
                        });
                        participants[value].seat.legs = bookingStats.participantsData[value].seat;
                    }
                });

                // set current
                let theIndex = 0;
                let p = [];
                _.filter(participants, function (o) {
                    if (o.seat === false) {
                        p.push(o);
                    } else if (
                        o.seat?.legs[currentLeg] === undefined ||
                        o.seat?.legs[currentLeg] === false ||
                        Object.keys(o.seat?.legs[currentLeg]).length === 0
                    ) {
                        p.push(o);
                    }
                });
                if (p.length > 0) {
                    Object.keys(participants).forEach((v) => (participants[v].current = false));

                    p[0].current = true;

                    Object.keys(participants).forEach((pV, pI) => {
                        if (participants[pV].current === true) {
                            theIndex = parseInt(pV);
                        }
                    });
                }

                this.setState({
                    current: theIndex,
                });
            }

            // set -> surcharge : legs
            Object.keys(legs).forEach((value, index) => {
                let legSurcharge = 0;
                _.filter(bookingStats.participantsData, function (o) {
                    if (o.seat[index]?.booked !== undefined) {
                        return false;
                    }
                    if (o.seat[index]?.price !== undefined) {
                        legSurcharge += o.seat[index].price;
                    }
                });

                legs[index].surcharge = legSurcharge;
                legs[index].success =
                    _.filter(participants, function (o) {
                        return o.participantType !== 'infant';
                    }).length ===
                    _.filter(bookingStats.participantsData, function (o) {
                        return (
                            o.participantType !== 'infant' && (o.seat === undefined || o.seat[index]?.success === true)
                        );
                    }).length;
            });

            // set -> totalSurcharge
            let totalSurcharge = 0;
            Object.keys(legs).forEach((v) => {
                if (legs[v]?.surcharge !== undefined) {
                    totalSurcharge += legs[v].surcharge;
                }
            });

            this.vacancy('all');

            this.setState({
                bookStates: bookingStats,
                participants: participants,
                totalSurcharge: parseFloat(totalSurcharge),
            });
        }
    }

    // set plane : seat active state
    preSelectSeats() {
        let bookingStats = this.state.bookStates;

        if (bookingStats === undefined) {
            return false;
        }

        Object.keys(bookingStats.participantsData).forEach((v) => {
            Object.keys(bookingStats.participantsData[v].seat).forEach((pV) => {
                let index = parseInt(pV);

                if (
                    document.querySelector(
                        '[data-offerkey="' + bookingStats.participantsData[v].seat[index].offerKey + '"] .cnt'
                    ) !== null
                ) {
                    document
                        .querySelector(
                            '[data-offerkey="' + bookingStats.participantsData[v].seat[index].offerKey + '"] .cnt'
                        )
                        .classList.add('selected', 'pre-select');

                    document
                        .querySelector(
                            '[data-offerkey="' + bookingStats.participantsData[v].seat[index].offerKey + '"] .cnt'
                        )
                        .setAttribute('index', parseInt(v) + 1);
                }
            });
        });
    }

    preSelectBookedLegs(bookingStats = null) {
        let { bookingData, legs, participants, currentLeg } = this.state;

        let bookedLegsInfo = bookingStats;
        if (bookingData.bookedService?.seatReservation !== undefined) {
            bookedLegsInfo = bookingData.bookedService?.seatReservation.bookingStats;
        }

        if (bookedLegsInfo !== null) {
            // participants
            Object.keys(bookedLegsInfo.participantsData).forEach((i) => {
                participants[i].success = true;
                participants[i].seat = {};
                participants[i].seat.legs = {};

                if (bookedLegsInfo.participantsData[i]?.seat === undefined) {
                    return false;
                }

                Object.keys(bookedLegsInfo.participantsData[i].seat).forEach((v) => {
                    if (bookedLegsInfo.participantsData[i].seat[v].offerKey !== undefined) {
                        bookedLegsInfo.participantsData[i].seat[v].booked = true;
                    }

                    // set plane : seat active state
                    let interval = setInterval(function () {
                        if (
                            document.querySelector(
                                '.seat[data-offerkey="' +
                                    bookedLegsInfo.participantsData[i].seat[v].offerKey +
                                    '"] .cnt'
                            ) !== null
                        ) {
                            set();
                        }
                    }, 500);

                    function set() {
                        clearInterval(interval);

                        if (
                            document.querySelector(
                                '.seat[data-offerkey="' +
                                    bookedLegsInfo.participantsData[i].seat[v].offerKey +
                                    '"] .cnt'
                            ) !== null
                        ) {
                            document
                                .querySelector(
                                    '.seat[data-offerkey="' +
                                        bookedLegsInfo.participantsData[i].seat[v].offerKey +
                                        '"] .cnt'
                                )
                                .classList.add('selected');

                            if (bookedLegsInfo.participantsData[i].seat[v].booked) {
                                document
                                    .querySelector(
                                        '.seat[data-offerkey="' +
                                            bookedLegsInfo.participantsData[i].seat[v].offerKey +
                                            '"] .cnt'
                                    )
                                    .classList.add('booked');
                            }

                            document
                                .querySelector(
                                    '.seat[data-offerkey="' +
                                        bookedLegsInfo.participantsData[i].seat[v].offerKey +
                                        '"] .cnt'
                                )
                                .setAttribute('index', parseInt(i) + 1);
                        }
                    }
                });

                participants[i].seat.legs = bookedLegsInfo.participantsData[i].seat;
            });

            // set current
            let theIndex = 0;
            let p = [];
            _.filter(participants, function (o) {
                if (o.seat === false) {
                    p.push(o);
                } else if (
                    o.seat?.legs[currentLeg] === undefined ||
                    o.seat?.legs[currentLeg] === false ||
                    Object.keys(o.seat?.legs[currentLeg]).length === 0
                ) {
                    p.push(o);
                }
            });
            if (p.length > 0) {
                Object.keys(participants).forEach((v) => (participants[v].current = false));

                p[0].current = true;

                Object.keys(participants).forEach((pV, pI) => {
                    if (participants[pV].current === true) {
                        theIndex = parseInt(pV);
                    }
                });
            }

            // leg info
            Object.keys(bookedLegsInfo.legData).forEach((i) => {
                legs[i].booked = true;

                let getAllParticipantsBooked = _.filter(bookedLegsInfo.participantsData, function (o) {
                    if (o?.seat !== undefined) {
                        return o.seat[i] !== undefined && o.seat[i].booked !== undefined && o.seat[i].booked === true;
                    }
                });

                let participantsCount = _.filter(participants, function (o) {
                    return o.participantType !== 'infant';
                });

                legs[i].allParticipantsBooked = getAllParticipantsBooked.length === participantsCount.length;
            });

            this.preSelectBookedParticipants();

            // get leg index to open first
            let getLegIndexToOpenfirst = _.findIndex(legs, function (o) {
                if (!o.allParticipantsBooked) {
                    return o;
                }
            });

            // totalSurcharge
            this.setState({
                current: theIndex,
                legs: legs,
                legIndexToOpen: getLegIndexToOpenfirst,
                participants: participants,
            });
        }
    }

    setBookedSeats() {
        // bookedSeats
        let { bookingData, participants, legs } = this.state;

        let bookedSeats = bookingData.data?.serviceInformation.bookedSeats;
        if (bookedSeats === undefined || bookedSeats.length === 0) {
            return false;
        }

        let legData = [];
        let participantsData = [];
        let legsArr = [];
        Object.keys(participants).forEach((v, pI) => {
            participantsData[pI] = {};
            legsArr[pI] = {};
            Object.keys(legs).forEach((v, lI) => {
                legsArr[pI][lI] = {};
            });
        });

        Object.keys(bookedSeats).forEach((bSV, bSI) => {
            const participantIndex = _.findKey(participants, function (o) {
                return o.forename === bookedSeats[bSI].participant.firstName;
            });

            // state : OK RQ
            if (bookedSeats[bSI].state === 'OK' || bookedSeats[bSI].state === 'RQ' || bookedSeats[bSI].state === 'MO') {
                // get leg index
                let legIndex = null;
                let seatCat = null;
                Object.keys(legs).forEach((v, i) => {
                    _.filter(legs[i].seatReservationOffers, function (o) {
                        if (o.offerKey === bookedSeats[bSI].offerKey) {
                            legIndex = i;
                            seatCat = o.category !== undefined && o.category;
                        }
                    });
                });

                if (legIndex === null) {
                    return false;
                }
                legIndex = parseInt(legIndex);

                // set leg data
                legData[legIndex] = {};
                legData[legIndex] = legs[legIndex] !== undefined && legs[legIndex];

                // set participant data
                legsArr[participantIndex][legIndex] = {
                    number: bookedSeats[bSI].seat,
                    cat: mappingSeatCategory[seatCat] !== undefined && mappingSeatCategory[seatCat],
                    price: bookedSeats[bSI].price,
                    offerKey: bookedSeats[bSI].offerKey,
                    booked: true,
                    success: true,
                };

                participantsData[participantIndex] = _.assign(participantsData[participantIndex], {
                    seat: legsArr[participantIndex],
                });
            }
        });

        this.preSelectBookedLegs({
            legData: legData,
            participantsData: participantsData,
        });
    }

    getAncillaries() {
        let $this = this;
        let bookingData = {
            ...this.state.bookingData,
        };

        if (storage.get('bookingData') === null) {
            return false;
        }

        if (bookingData?.data === null) {
            return false;
        }

        // set leg with infos / details
        const connectionLine = (legs, i) => {
            let departureDate = new Date(legs[i].transportInfo.departure.time);
            let arrivalDate = new Date(legs[i].transportInfo.arrival.time);
            let dateString;
            const options = {
                weekday: 'short',
                year: 'numeric',
                month: '2-digit',
                day: 'numeric',
            };

            if (departureDate !== null && arrivalDate !== null) {
                dateString =
                    departureDate.toLocaleString('de-DE', options) +
                    ' ' +
                    String(departureDate.getHours()).padStart(2, '0') +
                    ':' +
                    String(departureDate.getMinutes()).padStart(2, '0') +
                    ' Uhr' +
                    ' - ' +
                    String(arrivalDate.getHours()).padStart(2, '0') +
                    ':' +
                    String(arrivalDate.getMinutes()).padStart(2, '0') +
                    ' Uhr';

                return (
                    '<div>' +
                    legs[i].transportInfo.departure.airport.replace('Flughafen', '') +
                    ' (' +
                    legs[i].transportInfo.departure.airportCode +
                    ')' +
                    ' - ' +
                    legs[i].transportInfo.arrival.airport.replace('Flughafen', '') +
                    ' (' +
                    legs[i].transportInfo.arrival.airportCode +
                    ')' +
                    ' mit SunExpress XQ' +
                    legs[i].transportInfo.flightNumber +
                    '</div>' +
                    '<div> ' +
                    dateString +
                    '</div>'
                );
            }
        };

        let searchParams = bookingData.data.searchParams;
        let serviceInformation = bookingData.data.serviceInformation;

        if (window.$token === null && searchParams === null) {
            return false;
        }

        /*
         * the request
         */
        function request(sendData) {
            axios({
                url: window.$requestUrl + '/searchExtra?token=' + window.$token,
                method: 'POST',
                data: JSON.stringify(sendData),
            })
                .then((response) => response)
                .then((data) => {
                    if (data.data.statusmessage !== 'OK') {
                        $this.setState({
                            error: true,
                            isLoading: false,
                        });
                        return false;
                    }

                    // set result
                    let legsData = data.data.data.transportAncillaryOffers;

                    if (legsData.length > 0) {
                        // set legs
                        Object.keys(legsData).forEach((i) => {
                            let title = 'Hinflug';
                            _.forEach(bookingData.data.frontendParams.flightDetails, function (v, k) {
                                let o = k;
                                if (
                                    _.filter(v, {
                                        depAirportCode: legsData[i].transportInfo.departure.airportCode,
                                    }).length > 0
                                ) {
                                    switch (o) {
                                        case 'inbound':
                                            title = 'Rückflug';
                                            break;
                                        case 'outbound':
                                            title = 'Hinflug';
                                            break;
                                        default:
                                            break;
                                    }
                                }
                            });

                            legsData[i] = _.assign(legsData[i], {
                                success: false,
                                participants: 0,
                                // error : true,
                                title: title,
                                connection: connectionLine(legsData, i),
                                surcharge: 0,
                            });
                        });

                        $this.setState({
                            legs: legsData,
                        });

                        $this.setState({
                            hasResult: true,
                        });

                        $this.setState(
                            {
                                isLoading: false,
                            },
                            () => $this.preSelect()
                        );
                    } else {
                        $this.setState({
                            isLoading: false,
                        });
                    }
                })
                .catch((error) =>
                    $this.setState({
                        error,
                        isLoading: false,
                    })
                );
        }

        // get fileKeys
        let fileKeys = {};
        Object.keys(serviceInformation.flight).forEach((value, index) => {
            if (
                serviceInformation.flight[value].provider !== undefined &&
                serviceInformation.flight[value].ltCode !== undefined &&
                (serviceInformation.flight[value].provider === 'FCMS' ||
                    serviceInformation.flight[value].provider === 'FCMS SUB') &&
                serviceInformation.flight[value].ltCode === 'XQ_KMS'
            ) {
                switch (serviceInformation.flight[value].direction) {
                    case 'inbound':
                        if (new Date(bookingData.data.flightDetailParams.inboundDepartureDate) >= new Date()) {
                            fileKeys[serviceInformation.flight[value].bookingId] =
                                serviceInformation.flight[value].carrier;
                        }
                        break;
                    case 'outbound':
                        if (new Date(bookingData.data.flightDetailParams.outboundDepartureDate) >= new Date()) {
                            fileKeys[serviceInformation.flight[value].bookingId] =
                                serviceInformation.flight[value].carrier;
                        }
                        break;
                    default:
                        fileKeys[serviceInformation.flight[value].bookingId] = serviceInformation.flight[value].carrier;
                }
            }
        });

        // get flights segemnts
        let flightsSegemnts = {};
        Object.keys(serviceInformation.flight).forEach((value, index) => {
            let { bookingId, segments } = serviceInformation.flight[value];
            if (bookingId === undefined || segments === undefined) {
                return false;
            }

            flightsSegemnts[bookingId] = {
                segments: segments,
            };
        });

        const sendData = {
            clientId: 'customerarea',
            processToken: params.processToken,
            travelType: 'seatReservation',
            requestType: 'searchExtra',
            travelStart: convertDate(searchParams.depDate),
            travelEnd: convertDate(searchParams.retDate),
            fileKeys: fileKeys,
            flights: flightsSegemnts,
            preferredPaymentType: serviceInformation?.preferredPaymentType,
            paxAges: searchParams?.paxAges,
        };

        request(sendData);
    }

    Card() {
        const { participants, legs } = this.state;

        if (legs === null) {
            return false;
        }

        let $this = this;

        function the_participants(legIndex, seatIcon = true, priceInfo = true, booked = false) {
            let adults = [];
            let childs = [];

            const setCurrent = (index) => {
                // no success state
                if (!participants[index].success) {
                    // set all elements : false
                    Object.keys(participants).forEach((v) => (participants[v].current = false));

                    // set this elements : current
                    participants[index].current = true;
                    $this.setState({
                        current: index,
                    });
                }

                if (
                    document.querySelectorAll(
                        '.card[leg-index="' + $this.state.currentLeg + '"] .participants-cnt .entry'
                    )[index] !== undefined &&
                    document
                        .querySelectorAll('.card[leg-index="' + $this.state.currentLeg + '"] .participants-cnt .entry')
                        [index].getBoundingClientRect().x !== undefined
                ) {
                    let scrollLeft =
                        document
                            .querySelectorAll(
                                '.card[leg-index="' + $this.state.currentLeg + '"] .participants-cnt .entry'
                            )
                            [index].getBoundingClientRect().x +
                        document.querySelector('.card[leg-index="' + $this.state.currentLeg + '"] .participants-cnt')
                            .scrollLeft -
                        20;
                    document
                        .querySelector('.card[leg-index="' + $this.state.currentLeg + '"] .participants-cnt')
                        .scrollTo({
                            left: scrollLeft,
                            behavior: 'smooth',
                        });
                }
            };

            const remove = (e, index, legIndex) => {
                // kill vacancy call
                if (typeof params.cancelVacancy === 'function') {
                    params.cancelVacancy('cancel vacancy');
                    $this.setState({
                        formVacancy: false,
                    });
                }

                // remove seat selected state
                document
                    .querySelector(
                        '.card[leg-index="' +
                            legIndex +
                            '"] .seat.' +
                            participants[index].seat.legs[legIndex].number.replace(' ', '') +
                            ' .cnt'
                    )
                    .classList.remove('selected', 'pre-select');

                document
                    .querySelector('.seat[data-offerkey=' + participants[index].seat.legs[legIndex].offerKey + '] .cnt')
                    .removeAttribute('index');

                let $legs = $this.state.legs;
                if (participants[index].seat.legs[legIndex].price !== undefined) {
                    $legs[legIndex].surcharge =
                        $legs[legIndex].surcharge - participants[index].seat.legs[legIndex].price;

                    // total surcharge
                    $this.state.totalSurcharge =
                        $this.state.totalSurcharge - participants[index].seat.legs[legIndex].price;
                }

                // set participants count
                $legs[legIndex].participants = parseInt($legs[legIndex].participants) - 1;

                $legs[legIndex].success = false;
                $legs[legIndex].error = false;

                // remove seat error class
                document
                    .querySelector('.seat[data-offerkey=' + participants[index].seat.legs[legIndex].offerKey + ']')
                    .classList.remove('has-error');

                participants[index].success = false;
                participants[index].current = true;
                participants[index].seat.legs[$this.state.currentLeg] = false;

                setCurrent(index);

                $this.setState({
                    participants: participants,
                    formSubmit: false,
                });
            };

            const logic = (e, index, legIndex) => {
                if (
                    $this.state.participants[index] !== undefined &&
                    $this.state.participants[index].participantType === 'infant'
                ) {
                    return false;
                }

                setCurrent(index);

                let legs = {
                    ...$this.state.legs,
                };
                legs[$this.state.currentLeg].errorText = null;
                $this.setState({
                    legs: legs,
                });

                if (e.target.classList.contains('close')) {
                    remove(e, index, legIndex);
                }

                // set class : not allowed to book emergency seats
                $this.setIsEmergencySeatsAvailable(index);
            };

            function handleHover(e, index) {
                if (e.target.closest('.entry').classList.contains('success')) {
                    document
                        .querySelectorAll('.card[leg-index="' + $this.state.currentLeg + '"] .seat .cnt')
                        .forEach((element) => {
                            element.classList.remove('hover');
                        });
                    if (
                        document.querySelector(
                            '.card[leg-index="' + $this.state.currentLeg + '"] .seat .cnt[index="' + (index + 1) + '"]'
                        ) !== null
                    ) {
                        document
                            .querySelector(
                                '.card[leg-index="' +
                                    $this.state.currentLeg +
                                    '"] .seat .cnt[index="' +
                                    (index + 1) +
                                    '"]'
                            )
                            .classList.add('hover');
                    }
                }
            }

            Object.keys(participants).forEach((value, index) => {
                let tmpl = (
                    <div
                        className={`entry 
						${
                            participants[index]?.seat.legs !== undefined &&
                            participants[index]?.seat.legs[legIndex] !== undefined &&
                            participants[index].seat.legs[legIndex]?.success &&
                            !participants[index]?.seat.legs[legIndex].error &&
                            !participants[index]?.seat.legs[legIndex].error
                                ? 'success'
                                : ''
                        }
	
						${
                            participants[index]?.seat.legs !== undefined &&
                            participants[index]?.seat.legs[legIndex] !== undefined &&
                            participants[index]?.seat.legs[legIndex].error
                                ? 'select-new-seat'
                                : ''
                        } 
                                
						${
                            $this.state?.legs !== undefined &&
                            participants[index]?.seat === false &&
                            $this.state?.legs[legIndex].errorText !== null &&
                            $this.state?.legs[legIndex].errorText !== undefined
                                ? 'error'
                                : ''
                        }
                               
					   ${participants[index]?.participantType}
					   
						${participants[index]?.current ? 'current' : ''}`}
                        key={index}>
                        <div
                            className="cnt"
                            onClick={(e) => {
                                logic(e, index, legIndex);
                            }}
                            onMouseEnter={(e) => handleHover(e, index)}
                            onMouseLeave={(e) =>
                                document
                                    .querySelectorAll('.card[leg-index="' + $this.state.currentLeg + '"] .seat .cnt')
                                    .forEach((element) => {
                                        element.classList.remove('hover');
                                    })
                            }>
                            {/*
								seatIcon
							*/}
                            {seatIcon && participants[index]?.participantType !== 'infant' && (
                                <>
                                    <div className="icon">
                                        <span className="index">{index + 1}</span>
                                    </div>
                                    {participants[index]?.seat.legs !== undefined &&
                                        participants[index].seat.legs[legIndex]?.success && (
                                            <i className="close material-icons">close</i>
                                        )}
                                </>
                            )}
                            <div className="name">
                                <span className="forename">{participants[index].forename}</span>{' '}
                                <span className="surname">{participants[index].surname}</span>
                            </div>
                        </div>

                        <div className="seat-cnt">
                            {participants[index].seat.legs !== undefined && participants[index].seat.legs[legIndex] ? (
                                <>
                                    {participants[index].seat.legs[legIndex].number &&
                                        !participants[index].seat.legs[legIndex].error && (
                                            <>
                                                {/*
												show seat number
											*/}
                                                <div className="number">
                                                    {participants[index].seat.legs[legIndex].number}
                                                    <small>
                                                        (
                                                        {participants[index].seat.legs[legIndex].cat.name !== undefined
                                                            ? participants[index].seat.legs[legIndex].cat.name
                                                            : mappingSeatCategory[
                                                                  participants[index].seat.legs[legIndex].cat
                                                              ].name}
                                                        )
                                                    </small>
                                                </div>

                                                {/*
												show seat price info
											*/}
                                                {priceInfo && (
                                                    <div className="price">
                                                        +{' '}
                                                        {convertPrice(
                                                            participants[index].seat.legs[legIndex].price,
                                                            0,
                                                            2
                                                        )}
                                                    </div>
                                                )}
                                            </>
                                        )}

                                    {/*
										seat error
									*/}
                                    {participants[index].seat.legs[legIndex].error && (
                                        <div className="seat-error">
                                            <i className="material-symbols-outlined">report</i>
                                            <span>Bitte wählen Sie einen neuen Sitzplatz.</span>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <>
                                    {participants[index].participantType === 'infant' ? (
                                        <label className="info" htmlFor={`infant-info-${index}-${legIndex}`}>
                                            <input type="checkbox" id={`infant-info-${index}-${legIndex}`} />
                                            <i className="material-icons">info_outline</i>
                                            <div className="info-layer">
                                                <div className="corner"></div>
                                                <div className="content">
                                                    Für Kleinkinder zwischen 0 und 2 Jahren ist die Reservierung eines
                                                    eigenen Sitzplatzes nicht möglich, da diese auf dem Schoß der
                                                    Eltern/Erziehungsberechtigten reisen.
                                                </div>
                                            </div>
                                        </label>
                                    ) : (
                                        <div className="default">---</div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                );
                if (booked) {
                    if (
                        (participants[index]?.seat.legs !== undefined &&
                            participants[index]?.seat.legs[legIndex] !== undefined &&
                            participants[index].seat.legs[legIndex]?.booked) ||
                        participants[index].participantType === 'infant'
                    ) {
                        if (participants[index].participantType === 'adult') {
                            adults.push(tmpl);
                        }

                        if (
                            participants[index].participantType === 'child' ||
                            ($this.state.legs[legIndex]?.allParticipantsBooked !== undefined &&
                                $this.state.legs[legIndex].allParticipantsBooked &&
                                participants[index].participantType === 'infant')
                        ) {
                            childs.push(tmpl);
                        }
                    }
                } else {
                    if (
                        !(
                            participants[index]?.seat.legs !== undefined &&
                            participants[index]?.seat.legs[legIndex] !== undefined &&
                            participants[index].seat.legs[legIndex]?.booked
                        )
                    ) {
                        if (participants[index].participantType === 'adult') {
                            adults.push(tmpl);
                        }

                        if (
                            participants[index].participantType === 'child' ||
                            participants[index].participantType === 'infant'
                        ) {
                            childs.push(tmpl);
                        }
                    }
                }
            });

            return (
                <div className="participants">
                    {adults.length > 0 && (
                        <div>
                            <div className="top-line">
                                <h3 className="title">Erwachsene</h3>
                                <div className="legend">
                                    <div className="title">Sitzplatz</div>
                                </div>
                            </div>

                            <div className="cnt">{adults}</div>
                        </div>
                    )}

                    {childs.length > 0 && (
                        <div>
                            <div className="top-line">
                                <h3 className="title">Kinder</h3>
                                <div className="legend">
                                    <div className="title">Sitzplatz</div>
                                </div>
                            </div>
                            <div className="cnt">{childs}</div>
                        </div>
                    )}
                </div>
            );
        }

        function Plane(legIndex) {
            const { seatMap } = legs[legIndex];

            let seat_row_with_break = [];
            seatMap.columns.forEach((i) => {
                if (seatMap.columns[i + 1] === seatMap.aisleColumns[i]) {
                    seat_row_with_break.push(i);
                } else {
                    seat_row_with_break.push(i);
                    seat_row_with_break.push('break');
                }
            });

            let seat_row_legend = [];
            let seat_row = [];
            let theIndex = null;

            const setCurrent = (index) => {
                let pArr = _.filter(participants, function (o) {
                    if (o.participantType === 'infant') {
                        return false;
                    }
                    if (o.seat === false) {
                        return o;
                    }

                    if (
                        o.seat?.legs[$this.state.currentLeg] === undefined ||
                        o.seat?.legs[$this.state.currentLeg] === false ||
                        Object.keys(o.seat?.legs[$this.state.currentLeg]).length === 0
                    ) {
                        return o;
                    }
                });

                if (pArr.length > 0) {
                    Object.keys(participants).forEach((v) => (participants[v].current = false));

                    pArr[0].current = true;

                    Object.keys(participants).forEach((pV, pI) => {
                        if (participants[pV].current === true) {
                            theIndex = parseInt(pV);
                        }
                    });
                }
                if (
                    document.querySelectorAll(
                        '.card[leg-index="' + $this.state.currentLeg + '"] .participants-cnt .entry'
                    )[theIndex] !== undefined &&
                    document
                        .querySelectorAll('.card[leg-index="' + $this.state.currentLeg + '"] .participants-cnt .entry')
                        [theIndex].getBoundingClientRect().x !== undefined
                ) {
                    let scrollLeft =
                        document
                            .querySelectorAll(
                                '.card[leg-index="' + $this.state.currentLeg + '"] .participants-cnt .entry'
                            )
                            [theIndex].getBoundingClientRect().x +
                        document.querySelector('.card[leg-index="' + $this.state.currentLeg + '"] .participants-cnt')
                            .scrollLeft -
                        20;
                    document
                        .querySelector('.card[leg-index="' + $this.state.currentLeg + '"] .participants-cnt')
                        .scrollTo({
                            left: scrollLeft,
                            behavior: 'smooth',
                        });
                }

                // set class : not allowed to book emergency seats
                $this.setIsEmergencySeatsAvailable(theIndex);
            };

            const seat = (
                cat = 'Standardsitz',
                offerKey,
                number = null,
                occupation = 'available',
                price = 0,
                positions = null
            ) => {
                function handleClick(e) {
                    // kill vacancy call
                    tracking('interaction', 'seatReservation');
                    if (typeof params.cancelVacancy === 'function') {
                        params.cancelVacancy('cancel vacancy');
                        $this.setState({
                            formVacancy: false,
                        });
                    }

                    let legs = {
                        ...$this.state.legs,
                    };
                    let participants = {
                        ...$this.state.participants,
                    };

                    if ($this.state.current < 0) {
                        theIndex = 0;
                    } else {
                        theIndex = $this.state.current;
                    }
                    if (e.target.getAttribute('index') !== null) {
                        theIndex = parseInt(e.target.getAttribute('index')) - 1;
                    }

                    // no way
                    if (!e.target.classList.contains('has-error')) {
                        if (
                            occupation !== 'available' ||
                            ($this.state.legs[$this.state.currentLeg].success === true &&
                                !e.target.classList.contains('selected')) ||
                            ($this.state.participants[theIndex] !== undefined &&
                                $this.state.participants[theIndex].participantType === 'infant') ||
                            e.target.classList.contains('booked')
                        ) {
                            return false;
                        }
                    }

                    // case : seat → exit
                    if (positions.includes('exit') && !e.target.classList.contains('selected')) {
                        // no way : has infant
                        let hasInfant = _.filter(participants, function (o) {
                            return o.participantType === 'infant';
                        });
                        if (hasInfant.length > 0) {
                            return false;
                        }

                        // default
                        let layers = {
                            ...$this.state.layers,
                        };

                        layers.EmergencySeat = {
                            show: true,
                            details: {
                                theIndex: theIndex,
                                legIndex: legIndex,
                            },
                        };
                        $this.setState({
                            layers: layers,
                        });

                        // not allowed to book seat for childs < 14 and infants
                        if (participants[theIndex].participantType !== 'adult') {
                            return false;
                        }
                    }

                    // deselect seat
                    if (e.target.classList.contains('selected')) {
                        let legIndex = $this.state.currentLeg;
                        let index = parseInt(e.target.getAttribute('index')) - 1;

                        e.target.classList.remove('selected', 'pre-select');

                        // remove seat selected state && index
                        document
                            .querySelector(
                                '.seat[data-offerkey=' + participants[index].seat.legs[legIndex].offerKey + ']'
                            )
                            .classList.remove('selected');
                        document
                            .querySelector(
                                '.seat[data-offerkey=' + participants[index].seat.legs[legIndex].offerKey + '] .cnt'
                            )
                            .removeAttribute('index');

                        if (participants[index].seat.legs[legIndex].price !== undefined) {
                            legs[legIndex].surcharge =
                                Number.parseFloat(legs[legIndex].surcharge).toFixed(2) -
                                Number.parseFloat(participants[index].seat.legs[legIndex].price).toFixed(2);

                            // total surcharge
                            $this.state.totalSurcharge =
                                Number.parseFloat($this.state.totalSurcharge).toFixed(2) -
                                Number.parseFloat(participants[index].seat.legs[legIndex].price).toFixed(2);
                        }

                        // set participants count
                        legs[legIndex].participants = parseInt(legs[legIndex].participants) - 1;

                        legs[legIndex].success = false;
                        legs[legIndex].error = false;

                        // remove seat error class
                        document
                            .querySelector(
                                '.seat[data-offerkey=' + participants[index].seat.legs[legIndex].offerKey + ']'
                            )
                            .classList.remove('has-error');

                        participants[index].success = false;
                        participants[index].current = true;
                        participants[index].seat.legs[$this.state.currentLeg] = false;

                        // setCurrent
                        Object.keys(participants).forEach((v) => (participants[v].current = false));
                        participants[index].current = true;

                        $this.setState({
                            participants: participants,
                            current: index,
                            formSubmit: false,
                        });

                        // set class : not allowed to book emergency seats
                        $this.setIsEmergencySeatsAvailable(index);

                        return false;
                    }

                    // select seat
                    participants[theIndex].current = false;
                    participants[theIndex].success = true;

                    e.target.classList.add('selected');
                    e.target.setAttribute('index', parseInt(theIndex + 1));

                    if (participants[theIndex].seat === false) {
                        participants[theIndex].seat = {};
                    }
                    if (participants[theIndex].seat['legs'] === undefined) {
                        participants[theIndex].seat['legs'] = [];
                    }
                    participants[theIndex].seat.legs[legIndex] = {};
                    participants[theIndex].seat.legs[legIndex] = {
                        number: number,
                        cat: cat,
                        price: price,
                        offerKey: offerKey,
                        success: true,
                    };

                    // set leg state success
                    legs[$this.state.currentLeg].success =
                        _.filter(participants, function (o) {
                            return o.participantType !== 'infant';
                        }).length ===
                        _.filter(participants, function (o) {
                            return (
                                o.participantType !== 'infant' &&
                                o.seat?.legs !== undefined &&
                                o.seat?.legs[$this.state.currentLeg] !== undefined &&
                                o.seat?.legs[$this.state.currentLeg].success === true
                            );
                        }).length;

                    // pre select next element
                    setCurrent();

                    $this.setState({
                        participants: participants,
                        current: theIndex,
                    });

                    // set new surcharge
                    legs[$this.state.currentLeg].surcharge = legs[$this.state.currentLeg].surcharge + price;
                    $this.state.totalSurcharge = $this.state.totalSurcharge + price;

                    // set participants count
                    legs[$this.state.currentLeg].participants = parseInt(legs[$this.state.currentLeg].participants) + 1;

                    // remove errors
                    let formErrors = $this.state.formErrors;
                    formErrors.submit.state = false;
                    formErrors.submit.responseText = '';

                    legs[$this.state.currentLeg].errorText = null;

                    //  if all possible seats : auto vacancy
                    let allLegsSuccess = _.filter(legs, function (o) {
                        return o.success;
                    });
                    if (allLegsSuccess.length === Object.keys(legs).length) {
                        $this.vacancy('all');
                    }

                    $this.setState({
                        legs: legs,
                        formErrors: formErrors,
                        formSubmit: false,
                    });

                    return e.target.classList;
                }

                function handleHover(e, positions) {
                    if (e.target.classList.contains('selected')) {
                        document
                            .querySelectorAll(
                                '.card[leg-index="' + $this.state.currentLeg + '"] .participants-cnt .entry'
                            )
                            .forEach((element) => {
                                element.classList.remove('hover');
                            });
                        let index = e.target.getAttribute('index');
                        if (
                            document.querySelectorAll(
                                '.card[leg-index="' + $this.state.currentLeg + '"] .participants-cnt .entry'
                            )[index - 1] !== undefined
                        ) {
                            document
                                .querySelectorAll(
                                    '.card[leg-index="' + $this.state.currentLeg + '"] .participants-cnt .entry'
                                )
                                [index - 1].classList.add('hover');
                        }
                    }
                }

                return (
                    <div
                        key={number}
                        data-offerkey={offerKey}
                        className={`seat ${cat} ${number.replace(' ', '')} 
							 ${occupation === 'available' ? 'available' : 'no-available '} 
							 ${positions !== null ? positions.join(' ') : ''}`}>
                        <span
                            className="cnt"
                            onClick={(e) => handleClick(e)}
                            onMouseEnter={(e) => handleHover(e, positions)}
                            onMouseLeave={(e) =>
                                document
                                    .querySelectorAll(
                                        '.card[leg-index="' + $this.state.currentLeg + '"] .participants-cnt .entry'
                                    )
                                    .forEach((element) => {
                                        element.classList.remove('hover');
                                    })
                            }></span>
                    </div>
                );
            };

            // set seat row legend
            Object.keys(seat_row_with_break).forEach((i) => {
                if (seat_row_with_break[i] === 'break') {
                    seat_row_legend.push(<div className="line-number" key={i}></div>);
                } else {
                    seat_row_legend.push(<div key={i}>{seat_row_with_break[i]}</div>);
                }
            });

            const seat_row_entry = (number) => {
                let entry = [];
                Object.keys(seat_row_with_break).forEach((i) => {
                    if (seat_row_with_break[i] === 'break') {
                        entry.push(
                            <div className="line-number" key={i}>
                                {number}
                            </div>
                        );
                    } else {
                        let seatReservationOffers = _.filter(legs[legIndex].seatReservationOffers, {
                            column: seat_row_with_break[i],
                            row: number.toString(),
                        });

                        let category = 'xleg';
                        let offerKey = null;
                        let occupation = null;
                        let price = null;
                        let positions = null;

                        if (seatReservationOffers.length > 0) {
                            if (seatReservationOffers[0].category !== null) {
                                category = seatReservationOffers[0].category;
                            }
                            if (seatReservationOffers[0].offerKey !== null) {
                                offerKey = seatReservationOffers[0].offerKey;
                            }
                            if (seatReservationOffers[0].occupation !== null) {
                                occupation = seatReservationOffers[0].occupation;
                            }
                            if (seatReservationOffers[0].price !== null) {
                                price = seatReservationOffers[0].price.overallGrossPrice;
                            }
                            if (seatReservationOffers[0].positions !== null) {
                                positions = seatReservationOffers[0].positions;
                            }
                        }

                        entry.push(
                            seat(
                                category,
                                offerKey,
                                seat_row_with_break[i] + ' ' + number,
                                occupation,
                                price,
                                positions
                            )
                        );
                    }
                });

                return entry;
            };

            Object.keys(seatMap.rows).forEach((key) => {
                let i = seatMap.rows[key];

                let classList = `seat-row ${'row-count-' + i}`;
                if (seatMap.wingRows.includes(i)) {
                    classList += ' wing-rows';
                }

                let wingRowLabel = <div key={1000} className="wing-row-label"></div>;

                seat_row.push(
                    <div className={classList} key={i}>
                        {i === parseInt(seatMap.wingRows[0]) && wingRowLabel}
                        {seat_row_entry(i)}
                    </div>
                );
            });

            return (
                <div
                    className={`plain-cnt ${
                        $this.state.legs[$this.state.currentLeg] !== undefined &&
                        $this.state.legs[$this.state.currentLeg].success
                            ? 'no-available'
                            : 'available'
                    }`}>
                    <div className="plain">
                        <div className="seat-row-legend">{seat_row_legend}</div>
                        {seat_row}
                    </div>
                </div>
            );
        }

        function Categories(legIndex) {
            let { categoryInfos } = legs[legIndex];

            let entries = [];

            Object.keys(categoryInfos).forEach((i) => {
                if (categoryInfos[i].minPrice === null) {
                    return false;
                }
                entries.push(
                    <div className={`e ${categoryInfos[i].name}`} key={i}>
                        <div className="description">
                            <div className="icon"></div>
                            <div>
                                {mappingSeatCategory[categoryInfos[i].name].name !== undefined && (
                                    <div className="title">{mappingSeatCategory[categoryInfos[i].name].name}</div>
                                )}
                                {mappingSeatCategory[categoryInfos[i].name].info !== undefined && (
                                    <p className="info">{mappingSeatCategory[categoryInfos[i].name].info}</p>
                                )}
                            </div>
                        </div>

                        {categoryInfos[i].minPrice !== undefined && (
                            <div className="price">
                                + {categoryInfos[i].minPrice > 0 && 'ab'}{' '}
                                {convertPrice(categoryInfos[i].minPrice, 0, 2)} p.P.
                            </div>
                        )}
                    </div>
                );
            });

            return (
                <div className="e categories">
                    <div className="heading">Sitzplatzkategorien</div>

                    <div className="e no-available">
                        <div className="description">
                            <div className="icon"></div>
                            <div className="title">Sitz nicht verfügbar</div>
                        </div>
                    </div>

                    {entries}
                </div>
            );
        }

        function handleClick(e, index) {
            let currentLeg = index;

            $this.setIsEmergencySeatsAvailable();

            if (document.querySelectorAll('.top-head').length > 1) {
                if (e.target.closest('.top-head').classList.contains('open')) {
                    e.target.closest('.top-head').classList.remove('open');
                    currentLeg = index + 1;
                } else {
                    document.querySelector('.card .top-head ').classList.remove('open');
                    e.target.closest('.top-head').classList.add('open');
                    currentLeg = index;
                }

                let participants = {
                    ...$this.state.participants,
                };
                if ($this.state.legs[index].success === true) {
                    Object.keys(participants).forEach((value, index) => {
                        participants[index].current = false;
                        participants[index].success = true;
                    });
                } else {
                    Object.keys(participants).forEach((value, index) => {
                        participants[index].success = false;
                    });
                }

                // set current
                let theIndex = 0;
                let p = _.filter(participants, function (o) {
                    if (o.participantType === 'infant') {
                        return false;
                    }
                    if (o.seat === false) {
                        return o;
                    }

                    if (
                        o.seat?.legs[index] === undefined ||
                        o.seat?.legs[index] === false ||
                        Object.keys(o.seat?.legs[index]).length === 0
                    ) {
                        return o;
                    }
                });

                if (p.length > 0) {
                    Object.keys(participants).forEach((v) => (participants[v].current = false));

                    p[0].current = true;

                    Object.keys(participants).forEach((pV, pI) => {
                        if (participants[pV].current === true) {
                            theIndex = parseInt(pV);
                        }
                    });
                }

                $this.setState({
                    currentLeg: currentLeg,
                    participants: participants,
                    current: theIndex,
                });

                // scroll to element
                if (document.querySelector('.top-head.open') !== null) {
                    const yOffset = -30;
                    const element = document.querySelector('.top-head.open');
                    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

                    window.scrollTo({
                        top: y,
                        behavior: 'smooth',
                    });
                }
            }
        }

        return Object.keys($this.state.legs).map((value, index) => {
            return (
                <section
                    className={`card ${$this.state.legs[index].booked ? 'booked' : ''}`}
                    key={index}
                    ref={this.myRef}
                    leg-index={index}
                    onMouseOver={(e) => {
                        this.setIsEmergencySeatsAvailable();

                        let participants = $this.state.participants;

                        if (index === $this.state.currentLeg) {
                            return false;
                        }

                        // set current
                        let theIndex = 0;
                        let p = _.filter(participants, function (o) {
                            if (o.participantType === 'infant') {
                                return false;
                            }
                            if (o.seat === false) {
                                return o;
                            }

                            if (
                                o.seat?.legs[index] === undefined ||
                                o.seat?.legs[index] === false ||
                                Object.keys(o.seat?.legs[index]).length === 0
                            ) {
                                return o;
                            }
                        });

                        if (p.length > 0) {
                            Object.keys(participants).forEach((v) => (participants[v].current = false));

                            p[0].current = true;

                            Object.keys(participants).forEach((pV, pI) => {
                                if (participants[pV].current === true) {
                                    theIndex = parseInt(pV);
                                }
                            });
                        }

                        $this.setState({
                            currentLeg: index,
                            participants: participants,
                            current: theIndex,
                        });
                    }}>
                    <div
                        className={`top-head ${index === $this.state.legIndexToOpen ? 'open' : ''}`}
                        onClick={(e) => handleClick(e, index)}>
                        <div className={`inline ${$this.state.legs[index].error === true ? 'leg-error' : ''}`}>
                            <div className="main">
                                <img className="carrier-logo" src="//www.aurumtours.de/img/airline/70/XQ.png" alt="" />
                                <div className="flight">
                                    <h3 className="title">{$this.state.legs[index].title}</h3>

                                    <div
                                        className="bound"
                                        dangerouslySetInnerHTML={{
                                            __html: $this.state.legs[index].connection,
                                        }}></div>

                                    {$this.state.legs[index].booked && (
                                        <>
                                            {$this.state.legs[index].allParticipantsBooked ? (
                                                <article>
                                                    <p>
                                                        Für diesen Flug haben Sie bereits alle Sitzplätze gebucht. Für
                                                        Änderungen kontaktieren Sie bitte unser{' '}
                                                        <a
                                                            href={`${window.$website}/service`}
                                                            target="_blank"
                                                            rel="noopener noreferrer">
                                                            Serviceteam
                                                        </a>
                                                        .
                                                    </p>
                                                </article>
                                            ) : (
                                                <article>
                                                    <p>
                                                        Für diesen Flug haben Sie für einen Teil der Reisenden bereits
                                                        Sitzplätz(e) gebucht. <br />
                                                        Weitere Sitzplatzbuchungen sind möglich.
                                                    </p>
                                                </article>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="finish">
                            <div>
                                <div className="description title">Aufpreis für diesen Flug</div>
                            </div>
                            <div>
                                <div className="price total-price">
                                    + {convertPrice($this.state.legs[index].surcharge, 0, 2)}
                                </div>
                                <div className="description">Gesamtpreis für alle Reisenden</div>
                            </div>
                        </div>
                    </div>
                    <div className="content">
                        <div className="main">
                            {$this.state.legs[index].booked && (
                                <div className="booking-info">
                                    <div className="participants-cnt" ref={(c) => ($this.$participantsContainer = c)}>
                                        {the_participants(index, false, false, true)}
                                    </div>
                                </div>
                            )}

                            {!$this.state.legs[index].allParticipantsBooked && (
                                <>
                                    <div className="grid">
                                        <div
                                            className="participants-cnt"
                                            ref={(c) => ($this.$participantsContainer = c)}>
                                            {the_participants(index)}
                                        </div>
                                        <div className="plane-section">
                                            <Scrollbar alwaysShowTracks={true}>{Plane(value)}</Scrollbar>
                                        </div>

                                        {Categories(index)}

                                        <div className="airplane-line">Boeing 737-800</div>
                                    </div>
                                    <div className="e seating-arrangements">{seating_arrangements()}</div>
                                </>
                            )}
                        </div>
                    </div>
                </section>
            );
        });
    }

    EmergencySeatLayer() {
        // seat postion = exit
        if (!this.state.layers.EmergencySeat.show) {
            return false;
        }

        let legs = {
            ...this.state.legs,
        };
        let layers = {
            ...this.state.layers,
        };
        let participants = {
            ...this.state.participants,
        };

        const close = () => {
            layers.EmergencySeat.show = false;
            this.setState({
                layers: layers,
            });
        };

        const reject = () => {
            let index = layers.EmergencySeat.details.theIndex;
            let legIndex = layers.EmergencySeat.details.legIndex;

            if (index > -1) {
                Object.keys(participants).forEach((v) => (participants[v].current = false));
                participants[index].current = true;

                this.setState({
                    current: index,
                });
            }

            if (
                participants[index].participantType === 'child' ||
                participants[index].seat.legs[legIndex]?.number === undefined
            ) {
                return false;
            }

            // remove seat selected state
            if (
                document.querySelector(
                    '.card[leg-index="' +
                        legIndex +
                        '"] .seat.' +
                        participants[index].seat.legs[legIndex].number.replace(' ', '') +
                        ' .cnt'
                ) !== undefined
            ) {
                document
                    .querySelector(
                        '.card[leg-index="' +
                            legIndex +
                            '"] .seat.' +
                            participants[index].seat.legs[legIndex].number.replace(' ', '') +
                            ' .cnt'
                    )
                    .classList.remove('selected', 'booked');
            }

            if (participants[index].seat.legs[legIndex].price !== undefined) {
                legs[legIndex].surcharge = legs[legIndex].surcharge - participants[index].seat.legs[legIndex].price;

                // total surcharge
                this.setState({
                    totalSurcharge: this.state.totalSurcharge - participants[index].seat.legs[legIndex].price,
                });
            }

            legs[legIndex].success = false;

            participants[index].success = false;
            participants[index].current = true;
            participants[index].seat.legs[this.state.currentLeg] = false;

            this.setState({
                participants: participants,
            });
        };

        return (
            <div className="emergency-seat-layer">
                <div className="inline">
                    <div className="head">
                        <div className="aurum-logo"></div>

                        <div
                            className="close"
                            onClick={(e) => {
                                close();
                                reject();
                            }}>
                            <i className="material-symbols-outlined">close</i>
                        </div>
                    </div>
                    <Scrollbar>
                        <div className="content">
                            <h3>Für Sitzplatzreservierungen an einem Notausgang gelten folgende Bestimmungen:</h3>

                            <ul>
                                <li>Nur Personen älter als 14 Jahre</li>
                                <li>Keine Kleinkinder und alleinreisende Kinder</li>
                                <li>Keine Passagiere mit kleinen Haustieren in der Kabine</li>
                                <li>Keine schwangeren Personen</li>
                                <li>Nur Personen in bester physischer und psychischer Gesundheit</li>
                                <li>
                                    Die Anweisungen des Kabinenpersonals müssen verstanden werden (Deutsch/Türkisch oder
                                    Englisch)
                                </li>
                                <li>
                                    Nur Personen, die bei handlungsunfähiger Kabinenbesatzung eigenständig über das
                                    Öffnen der Notausgänge entscheiden und eine Evakuierung einleiten können
                                </li>
                                <li>
                                    Bewegungsfreiheit darf nicht eingeschränkt sein (etwa durch Körpermaße, Gewicht,
                                    Alter oder einen zusätzlich angelegten Sitzgurt)
                                </li>
                                <li>
                                    Keine Begleitpersonen von Reisenden, die in einer Notsituation auf Hilfe angewiesen
                                    ist (z. B. Kleinkind/Kind, Personen mit eingeschränkter Beweglichkeit)
                                </li>
                                <li>
                                    Keine Personen, die zwangsweise abgeschoben werden (Deportees), denen die Einreise
                                    verwehrt wurde bzw. wird oder bei denen es sich um in Gewahrsam genommene Gefangene
                                    handelt
                                </li>
                                <li>Keine Personen mit zu hohen Schuhabsätzen.</li>
                            </ul>

                            <p>
                                Das Check-in Personal sowie das Bordpersonal sind aus Sicherheitsgründen dazu
                                verpflichtet, die Eignung der Passagiere für einen Notausgangsplatz zu überprüfen.
                                SunExpress behält sich deshalb das Recht vor, Passagiere gegebenenfalls auf andere
                                Plätze einzuchecken bzw. umzusetzen. Eine Rückerstattung der Reservierungsgebühr ist in
                                einem solchen Fall nicht möglich.
                            </p>
                        </div>
                    </Scrollbar>

                    <div className="footer">
                        <button
                            className="btn"
                            onClick={(e) => {
                                close();
                            }}>
                            Ja, ich habe die Bestimmungen verstanden
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    setIsEmergencySeatsAvailable(index = this.state.current) {
        if (document.querySelector('.card[leg-index="' + this.state.currentLeg + '"]') !== undefined) {
            let getAllEmergencySeats = document.querySelectorAll(
                '.card[leg-index="' + this.state.currentLeg + '"] .seat.exit'
            );
            if (this.state.participants[index].participantType !== 'adult') {
                getAllEmergencySeats.forEach(function (emergencySeat, index) {
                    if (!emergencySeat.firstChild.classList.contains('selected')) {
                        emergencySeat.classList.add('no-available-emergency-seat-child');
                    }
                });
            } else {
                getAllEmergencySeats.forEach(function (emergencySeat, index) {
                    emergencySeat.classList.remove('no-available-emergency-seat-child');
                });
            }

            // has infant
            let hasInfant = _.filter(this.state.participants, function (o) {
                return o.participantType === 'infant';
            });

            if (hasInfant.length > 0) {
                getAllEmergencySeats.forEach(function (emergencySeat, index) {
                    if (!emergencySeat.firstChild.classList.contains('selected')) {
                        emergencySeat.classList.add('no-available-emergency-seat');
                    }
                });
            }
        }
    }

    vacancy(state = 'leg', checkout = false) {
        let $this = this;

        var CancelToken = axios.CancelToken;

        let participants = {
            ...this.state.participants,
        };
        let currentLeg = this.state.currentLeg;

        let transportAncillaryOfferKeys = [];
        Object.keys(participants).forEach((key, index) => {
            let arrParticipants = _.filter(participants[key].seat.legs, function (o) {
                return o !== undefined && o !== null && o.success;
            });

            switch (state) {
                case 'leg':
                    if (participants[key].seat !== false && participants[key].seat.legs[currentLeg] !== undefined) {
                        if (!transportAncillaryOfferKeys.push(participants[key].seat.legs[currentLeg]?.booked)) {
                            transportAncillaryOfferKeys.push(participants[key].seat.legs[currentLeg].offerKey);
                        }
                    }
                    break;
                case 'all':
                    Object.keys(arrParticipants).forEach((pKey, pIndex) => {
                        if (arrParticipants[pKey].offerKey !== undefined && !arrParticipants[pKey]?.booked) {
                            transportAncillaryOfferKeys.push(arrParticipants[pKey].offerKey);
                        }
                    });
                    break;
                default:
                    break;
            }
        });

        // no way : transportAncillaryOfferKeys empty
        if (transportAncillaryOfferKeys.length === 0) {
            return false;
        }

        this.setState({
            formVacancy: true,
        });

        /*
         *  the request
         *  transportAncillaryOfferKeys enthält eine Liste an OfferKeys aus der SearchResponse die ausgewählt wurden.
         *  Eine Zuordnung zum Pax ist nicht notwendig.
         */
        function request(sendData, currentLeg) {
            axios({
                url: window.$requestUrl + '/vacancy?token=' + window.$token,
                method: 'POST',
                data: JSON.stringify(sendData),
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    params.cancelVacancy = c;
                }),
            })
                .then((response) => response)
                .then((data) => {
                    // Der requestToken identifiziert die Vakanz eindeutig.
                    // Anschließende book-Requests müssen immer einen Vakanz requestToken referenzieren.

                    $this.setState({
                        formVacancy: false,
                        isLoading: false,
                    });

                    setTimeout(function () {
                        $this.preSelectSeats();
                    }, 0);

                    switch (data.data.data?.overallPackageVacancyResult) {
                        case 'ok':
                            params['processToken'] = data.data.data.processToken;

                            if (state === 'all' && parseFloat($this.state.totalSurcharge) > 0) {
                                $this.setState({
                                    formSubmit: true,
                                });
                                params['vacancyToken'] = data.data.data.requestToken;
                            }

                            break;
                        case 'failed':
                            let legs = $this.state.legs;
                            let formErrors = $this.state.formErrors;

                            // error : seat
                            let seatReservationOffers = data.data.data.seatReservationOffers;
                            if (seatReservationOffers.length > 0) {
                                let failedOfferKeys = [];
                                Object.keys(seatReservationOffers).forEach((key, index) => {
                                    if (seatReservationOffers[key].occupation !== 'available') {
                                        failedOfferKeys.push(seatReservationOffers[key].offerKey);
                                    }
                                });
                                Object.keys(participants).forEach((key, index) => {
                                    Object.keys(participants[key].seat.legs).forEach((lKey, lIndex) => {
                                        if (_.includes(failedOfferKeys, participants[key].seat.legs[lKey].offerKey)) {
                                            participants[key].seat.legs[lKey].error = true;

                                            // add seat error class
                                            document
                                                .querySelector(
                                                    '.seat[data-offerkey=' +
                                                        participants[key].seat.legs[lKey].offerKey +
                                                        ']'
                                                )
                                                .classList.add('has-error');

                                            // add seat no available class
                                            document
                                                .querySelector(
                                                    '.seat[data-offerkey=' +
                                                        participants[key].seat.legs[lKey].offerKey +
                                                        ']'
                                                )
                                                .classList.remove('available');
                                            document
                                                .querySelector(
                                                    '.seat[data-offerkey=' +
                                                        participants[key].seat.legs[lKey].offerKey +
                                                        ']'
                                                )
                                                .classList.add('no-available');

                                            // error : leg
                                            legs[lKey].error = true;

                                            $this.setState({
                                                legs: legs,
                                            });
                                        }
                                    });
                                });
                            }

                            // error : submit
                            formErrors.submit.state = true;
                            formErrors.submit.responseText = params.errorWording.submit['new-seats'];

                            $this.setState({
                                participants: participants,
                                formErrors: formErrors,
                            });
                            break;
                        default:
                            break;
                    }
                })
                .catch(function (thrown) {
                    if (axios.isCancel(thrown)) {
                        console.log('Request canceled :', thrown.message);
                    } else {
                        // handle error
                    }
                });
        }

        const sendData = {
            clientId: 'customerarea',
            processToken: params.processToken,
            travelType: 'seatReservation',
            requestType: 'vacancy',
            vacancyType: 'complete',
            ignoreCache: true,
            transportAncillaryOfferKeys: transportAncillaryOfferKeys,
        };

        // cancel previous request
        if (state === 'all') {
            if (typeof params.cancelVacancy === 'function') {
                params.cancelVacancy('cancel vacancy');
            }
        }
        request(sendData, this.state.currentLeg);
    }

    toTheCheckout() {
        let $this = this;
        let { legs, totalSurcharge } = this.state;

        function handleClick() {
            let participantsPerLeg = _.filter(legs, function (o) {
                return o.participants;
            });
            let formErrors = $this.state.formErrors;
            switch (true) {
                case participantsPerLeg.length === 0:
                    formErrors.submit.state = true;
                    formErrors.submit.responseText = params.errorWording.submit['no-pax-select'];

                    $this.setState({
                        formErrors: formErrors,
                    });
                    return false;
                case parseFloat($this.state.totalSurcharge) === 0:
                    formErrors.submit.state = true;
                    formErrors.submit.responseText = params.errorWording.submit['no-pax-select'];

                    $this.setState({
                        formSubmit: false,
                        formErrors: formErrors,
                    });
                    return false;
                default:
                    break;
            }

            if (formErrors.submit.state) {
                return false;
            }

            // set form vacancy state
            $this.setState({
                triggerFormVacancy: true,
            });
            // unchange
            if (!$this.state.formSubmit) {
                $this.vacancy('all', true);
            }

            // direkt zum Check-out
            let allParticipantsChoosen = true;
            if ($this.state.participants !== undefined) {
                Object.keys($this.state.participants).forEach((o) => {
                    if (
                        $this.state.participants[o]?.participantType !== 'infant' &&
                        $this.state.participants[o].seat !== false &&
                        Object.keys($this.state.participants[o]?.seat?.legs).length <
                            Object.keys($this.state.legs).length
                    ) {
                        allParticipantsChoosen = false;
                        return;
                    }

                    if (allParticipantsChoosen && $this.state.participants[o]?.seat?.legs !== undefined) {
                        Object.keys($this.state.participants[o]?.seat?.legs).forEach((l) => {
                            if (
                                $this.state.participants[o].seat.legs[l] === undefined ||
                                $this.state.participants[o].seat.legs[l].offerKey === undefined
                            ) {
                                allParticipantsChoosen = false;
                            }
                        });
                    } else {
                        allParticipantsChoosen = false;
                    }
                });
            } else {
                allParticipantsChoosen = false;
            }

            if ($this.state.formSubmit) {
                let participantsData = {};

                Object.keys($this.state.participants).forEach((key, index) => {
                    let seat = {};

                    if ($this.state.participants[key].seat !== false) {
                        // check participants seats
                        if (
                            _.filter($this.state.participants[key].seat.legs, function (o) {
                                return o !== undefined && o.offerKey;
                            }).length === 0
                        ) {
                            return false;
                        }

                        Object.keys($this.state.participants[key].seat.legs).forEach((i) => {
                            seat[i] = {
                                number: $this.state.participants[key].seat.legs[i].number,
                                price: $this.state.participants[key].seat.legs[i].price,
                                cat:
                                    $this.state.participants[key].seat.legs[i].cat !== undefined &&
                                    $this.state.participants[key].seat.legs[i].cat.name !== undefined
                                        ? $this.state.participants[key].seat.legs[i].cat
                                        : mappingSeatCategory[$this.state.participants[key].seat.legs[i].cat],
                                offerKey: $this.state.participants[key].seat.legs[i].offerKey,
                            };
                            // already booked seat
                            if (
                                $this.state.participants[key].seat.legs[i].booked !== undefined &&
                                $this.state.participants[key].seat.legs[i].booked === true
                            ) {
                                seat[i] = _.assign(seat[i], {
                                    booked: true,
                                });
                            }
                        });

                        participantsData[key] = {
                            participantType: $this.state.participants[key].participantType,
                            surname: $this.state.participants[key].surname,
                            forename: $this.state.participants[key].forename,
                            seat: seat,
                        };
                    }
                });

                let legData = {};
                Object.keys(legs).forEach((key, index) => {
                    if (parseFloat(legs[key].surcharge) > 0) {
                        legData[key] = {
                            title: legs[key].title,
                            surcharge: legs[key].surcharge,
                            transportInfo: legs[key].transportInfo,
                        };
                        if (legs[key].booked !== undefined) {
                            legData[key] = _.assign(legData[key], {
                                booked: true,
                            });
                        }
                        let getAllParticipantsBooked = _.filter($this.state.participants, function (o) {
                            return (
                                o.seat !== false &&
                                o.seat.legs[key] !== undefined &&
                                o.seat.legs[key].booked !== undefined &&
                                o.seat.legs[key].booked === true
                            );
                        });

                        let participantsCount = _.filter($this.state.participants, function (o) {
                            return o.participantType !== 'infant';
                        });

                        legData[key].allParticipantsBooked =
                            getAllParticipantsBooked.length === participantsCount.length;
                    }
                });

                let bookStates = {
                    travelType: 'seatReservation',
                    processToken: params.processToken,
                    vacancyToken: params.vacancyToken,
                    legData: legData,
                    participantsData: participantsData,
                    totalSurcharge: totalSurcharge,
                    vacancyData: {
                        price: {
                            packagePrice: totalSurcharge,
                        },
                    },
                };
                sessionStorage.setItem('bookStates', JSON.stringify(bookStates));

                window.location.href = `#/buchung/${window.$content.extras['seatReservation'].link}`;
            }
        }

        return (
            <div className="submit-section">
                <div className="cnt">
                    <div className="title">Aufpreis für alle Flüge</div>
                    <div className="price total-price">+ {convertPrice(this.state.totalSurcharge, 0, 2)}</div>
                    <div className="description">Gesamtpreis für alle Reisenden</div>

                    {/* all legs are booked */}
                    {this.state.legs.length !==
                        _.filter(this.state.legs, function (o) {
                            return o.allParticipantsBooked;
                        }).length && (
                        <>
                            <div className="bottom">
                                {this.state.formErrors.submit.state && (
                                    <div className="error">
                                        <i className="material-symbols-outlined">report</i>
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: this.state.formErrors.submit.responseText,
                                            }}></p>
                                    </div>
                                )}

                                <button
                                    className={`btn ${this.state.formVacancy ? 'validate' : ''} ${
                                        this.state.formSubmit ? 'submit' : ''
                                    }`}
                                    onClick={(e) => handleClick()}>
                                    {this.state.formSubmit ? 'Jetzt Sitzplätze buchen' : 'Sitzplatzreservierung prüfen'}
                                    <i className="material-icons">arrow_forward</i>
                                    <span className="loader"></span>
                                </button>
                            </div>
                            {this.state.formSubmit && (
                                <div className="small-print">
                                    Im nächsten Schritt können Sie Ihre Daten noch einmal überprüfen
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        );
    }

    render() {
        const { isLoading, hasResult, error } = this.state;

        return (
            <div className="page-seat-reservation">
                <DetectMultipleTabs travelType="seatReservation" />

                <Header />

                {this.EmergencySeatLayer()}

                <div className="intro row">
                    <h1 className="main-headline">Sitzplätze für Ihren Flug auswählen und reservieren</h1>
                    {!isLoading && (
                        <div className="info">
                            <i className="material-symbols-outlined">info</i>Sitzplatzreservierungen sind nur für die
                            nachfolgend aufgelisteten Flüge möglich.
                        </div>
                    )}
                </div>

                {error ? (
                    <StatusPage subPage="seatReservation" error="error" />
                ) : (
                    <div className={`content-wrapper`}>
                        <main
                            className={`content ${Object.keys(this.state.legs).length === 1 ? 'single' : 'multi'} ${
                                this.state.triggerFormVacancy ? 'validate' : ''
                            }`}>
                            {isLoading ? (
                                <ProgressBar finish={hasResult} finishText={''} />
                            ) : hasResult ? (
                                <>
                                    {this.Card()}

                                    {this.toTheCheckout()}
                                </>
                            ) : (
                                <>
                                    <div className="error no-offers">
                                        <i className="material-symbols-outlined">report</i>
                                        Zu Ihrer Buchung sind aktuell leider keine Angebote verfügbar.
                                    </div>
                                    <div className="user-action back-to-menu">
                                        <BackButton class="button link" target="blank" />
                                    </div>
                                </>
                            )}
                        </main>
                    </div>
                )}

                <Footer />
            </div>
        );
    }
}

export default Index;
